/**
 * Human-readable Swedish labels for offering type keys.
 * Used in the qualify wizard summary to show friendly names
 * instead of internal identifiers.
 */
export const OFFERING_LABELS: Record<string, string> = {
  food_fika: 'Mat & fika',
  accommodation: 'Boende',
  farm_shop: 'Gårdsbutik',
  preorder_pickup: 'Förbeställning / hämta upp',
  farm_sales_other: 'Annan gårdsförsäljning',
  courses_workshops: 'Kurser & workshops',
  tours_guiding: 'Guidning & turer',
  events: 'Evenemang',
  animals_nature: 'Djur & natur',
  other: 'Något annat',
};

/** Map an array of offering keys to their Swedish labels. */
export function formatOfferings(keys: string[]): string {
  if (keys.length === 0) return '–';
  return keys.map((k) => OFFERING_LABELS[k] ?? k).join(' · ');
}
